<template lang='pug'>
  digi-flex.digi-input.component
    span.icon
      slot(name='icon')
        text-icon
    slot
      input(type='text' :placeholder='placeholder')
    .underline
</template>

<script>
  export default {
    name: 'digi-input',

    props: {
      placeholder: String
    },

    data() {
      return {
      }
    },

    methods: {
    }
  }
</script>

<style scoped lang="stylus">
  .digi-input.basic
    .icon
      display none 
      
  .digi-input.reversed
    flex-direction row-reverse
    .icon
      margin 0
      // :hover
      //   color white

  .digi-input
    position relative
    align-items baseline
    padding-top 16px
    color rgb(200 200 200)
    &.align-right
      text-align right
      .icon
        right 0
        left auto
      input
        &:focus, &:active
          &::placeholder
            transform-origin right
    input
      background 0
      border 0
      border-bottom 1px dotted rgb( 240 128 80 )
      &:focus 
        outline 0
        border 0
    .icon
      font-size 1.25em
      margin-right 1em
      position relative
      top 2px
    >>> input, >>> textarea
      flex-grow 1
      padding 24px 0 4px 0
      color inherit
      box-sizing border-box
      &:focus, &:active
        &::placeholder
          transition all 360ms
          transform-origin left
          transform scale(.8) translateY(-1.75em)
          opacity .75
          color var(--clr-text)
      &:focus + .underline
        transform: scale(1)

  .digi-input.centered input
    &:focus, &:active
      &::placeholder
        transform-origin center

  .digi-input.full
    width 100%

  .digi-input.large
    font-size 1.25em
  
  .digi-input.larger
    font-size 1.5em
    >>> input, >>> textarea
      &:focus, &:active
        &::placeholder
          transition all 360ms
          transform-origin left
          transform scale(.75) translateY(-1.5em)
          opacity .75
          color var(--clr-text)

  .underline
    position absolute
    background-color rgb( 240 128 80 )
    height 2px
    bottom -8px
    transform scale(0, 1)
    transition all 320ms
    width 100%
</style>
